// The party's activities on the glass: one screen for each kind the game
// sends (LLAMA_MODE.md, "Activities and names"). The activity's id rides
// every play, so the room drops a play for one that is over.

import type { Activity } from '../../protocol';
import { el } from '../dom';
import type { Page } from '../page';
import { say } from '../say';
import { STRINGS } from '../strings';
import { buildFill, liveFill } from './fill';
import { buildStage, liveStage } from './stage';
import { buildVote, liveVote } from './vote';

export function buildActivity(page: Page, activity: Activity): HTMLElement {
  if (activity.kind === 'vote') return buildVote(page, activity);
  if (activity.kind === 'stage') return buildStage(page, activity);
  if (activity.kind === 'fill') return buildFill(page, activity);
  const box = el('div', 'body');
  box.append(say(STRINGS.vote.unknown, 'note'));
  return box;
}

// The parts that tick: each vote's countdown, Fill's countdown.
export function liveActivity(page: Page, root: HTMLElement, activity: Activity): void {
  if (activity.kind === 'vote') liveVote(page, root, activity);
  if (activity.kind === 'stage') liveStage(page, root, activity);
  if (activity.kind === 'fill') liveFill(page, root, activity);
}
